import logger from "@next/core-logger"
import type {AxiosError} from "axios"
import axios from "../../utils/axios"
import ProductsApi from "../../config/api/products"
import {FRAGMENT_ITEMS_QUERY_STRING} from "../../config/constants"
import {urlSanitiser} from "../../utils/httpUrlTrimmer"

export const getStaticProductFragmentsById = async (
    headers,
    itemsString: string,
    _apiProxyVersion: string,
    baseUrl: string,
): Promise<string> => {
    try {
        const getStaticProductFragmentsById = ProductsApi("getStaticProductFragmentsById")
        const response = await axios({
            method: getStaticProductFragmentsById.method,
            url: `${urlSanitiser(baseUrl)}${getStaticProductFragmentsById.localEndpoint()}`,
            headers,
            params: {
                [FRAGMENT_ITEMS_QUERY_STRING]: itemsString,
            },
        })
        return response.data
    } catch (error) {
        const ex = error as AxiosError
        if (ex.response) {
            // Axios interceptors log this error already
            throw ex
        }
        logger.error(ex)
        throw ex
    }
}
